<template>
  <div class="flex h-full flex-col gap-32">
    <h1 class="heading-1">{{ i18n(translations.title) }}</h1>
    <OpportunitiesFilters
      v-model:brand="brand"
      v-model:categories="categories"
      v-model:competition-levels="competitionLevels"
      v-model:grades="grades"
      v-model:market-codes="marketCodes"
      @reset="reset"
    />
    <OpportunitiesTable
      v-model:page-number-input="pageNumber"
      v-model:page-size-input="pageSize"
      v-model:sort-by-input="sortBy"
      v-model:sort-order-input="sortOrder"
      :is-loading="status === 'pending'"
      :lastUpdatedAt="opportunities?.lastUpdatedAt ?? ''"
      :numberOfOpportunities="opportunities?.totalCount ?? 0"
      :opportunities="opportunities?.sourcingOpportunities ?? []"
      :pageCount="opportunities?.pageCount ?? 0"
      @see-more-average-selling-price="handleSeeMoreAverageSellingPrice"
      @see-more-margin="handleSeeMoreMargin"
    />

    <ModalSeeMoreMargin />
    <ModalSeeMoreAverageSellingPrice />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '~/scopes/buyback/constants'

import translations from './Opportunities.translations'
import ModalSeeMoreAverageSellingPrice from './components/ModalSeeMoreAverageSellingPrice.vue'
import ModalSeeMoreMargin from './components/ModalSeeMoreMargin.vue'
import OpportunitiesFilters from './components/OpportunitiesFilters.vue'
import OpportunitiesTable from './components/OpportunitiesTable.vue'
import { useFetchSourcingOpportunities } from './composables/useFetchSourcingOpportunities'

const {
  status,
  marketCodes,
  competitionLevels,
  brand,
  grades,
  categories,
  opportunities,
  pageSize,
  sortBy,
  sortOrder,
  pageNumber,
  reset,
} = useFetchSourcingOpportunities()
const i18n = useI18n()
const { trackClick } = useTracking()

function handleSeeMoreAverageSellingPrice() {
  trackClick({
    name: 'see_more_average_selling_price',
    zone: 'opportunities',
  })
  openModal(MODAL_NAMES.SEE_MORE_AVERAGE_SELLING_PRICE)
}

function handleSeeMoreMargin() {
  trackClick({
    name: 'see_more_margin',
    zone: 'opportunities',
  })
  openModal(MODAL_NAMES.SEE_MORE_MARGIN)
}
</script>
